import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { faArchive, faPlay } from "@fortawesome/free-solid-svg-icons";
import ModalAdd from "./ModalAdd";
import TabBar from "../../../components/ui/TabBar";
import axios from "axios";
import InfoNoData from "../../../components/global/InfoNoData";
import List from "./List";
import { load as supportLoad, messageLoad, messageAdd } from '../../../reducers/models/ticket';
import Chat from "../../../components/chat/Chat";
import ErrorAdd from "../../../util/ErrorAdd";
import LogError from "../../../components/LogError";

function Index() {

    const dispatch = useDispatch()

    //TAB START
    const [tab, setTab] = useState([
        { id_tab: 1, name: "Активные", icon: faPlay, showCount: false, loading: false, error: null }
        , { id_tab: 0, name: "Архив", icon: faArchive, showCount: false, loading: false, error: null }
    ]);

    const [filterShow, setFilterShow] = useState(false);
    const [tabSelected, setTabSelected] = useState(1);
    //TAB END

    const stateTicket = useSelector((state) => state.ticket);

    useEffect(() => {
        if (stateTicket.listLoaded.filter(a => a.id_status === 1).length === 0) {
            loadList(1);//Ожидание          
        }
        if (stateTicket.listLoaded.filter(a => a.id_status === 2).length === 0) {
            loadList(2);//В работе
        }
    }, []);

    const [loadingChat, setLoadingChat] = useState(false);
    const [loadingMessage, setLoadingMessage] = useState(false);

    const [chatName, setChatName] = useState(null);
    const [chatId, setChatId] = useState(null);
    const [messages, setMessages] = useState([]);

    const [modalAddShow, setModalAddShow] = useState(false);
    const [ticketShow, setTicketShow] = useState(false);

    function setLoading(id_tab, val) {
        setTab(tab_ => tab_.map(item => {
            if (item.id_tab === id_tab) {
                return { ...item, loading: val };
            }
            else {
                return item;
            }
        }))
    }

    function setError(id_tab, val) {
        setTab(tab_ => tab_.map(item => {
            if (item.id_tab === id_tab) {
                return { ...item, error: val };
            }
            else {
                return item;
            }
        }))
    }


    function loadList(id_status) {
        /*
        id_status:
        1	Ожидание
        2	В работе
        3	Закрыт
        */

        const id_tab = id_status === 0 ? 0 : 1;
        setLoading(id_tab, true);
        setError(id_tab, null);

        axios.get('/api_tracker/ticket/list', { params: { ID_Status: id_status, Step: 1, Count: 100 } })
            .then((res) => {
                if (res.data.Status == 1) {
                    dispatch(supportLoad({ list: res.data.Data, id_status: id_status }));
                    setLoading(id_tab, false);
                }
                else {
                    setLoading(id_tab, false);
                    //setLogList(res.Error);
                    setError(id_tab, res.Error);
                }
            })
            .catch((err) => {
                //setLogList('Неизвестная ошибка!');
                setError(id_tab, 'Неизвестная ошибка! Повторите попытку позже или обратитесь в техническую поддержку по электронной почте: support@biz-office.ru');
                setLoading(id_tab, false);
                ErrorAdd(err, window.location.href);
            })
    }

    function tabHandler(id_tab) {
        setTabSelected(id_tab)

        if (id_tab === 0) {
            if (stateTicket.listLoaded.filter(a => a.id_tab === 0).length === 0) {
                loadList(0);
            }
        }
    }

    function editHandler(model) {
        setChatName(model.Name);
        setChatId(model.ID_Ticket);
        setTicketShow(true);

        if (stateTicket.listMessageLoaded.filter(a => a.id_ticket === model.ID).length === 0) {
            setLoadingChat(true);
            axios.get('/api_tracker/ticket/messageList', { params: { ID_Ticket: model.ID_Ticket, Step: 1, Count: 100 } })
                .then((res) => {
                    if (res.data.Status == 1) {
                        dispatch(messageLoad({ list: res.data.Data, id_ticket: model.ID_Ticket }));
                    }
                    else {
                        setLoading(false);
                        //setLog(res.Error);
                    }
                    setLoadingChat(false);
                })
                .catch((err) => {
                    setLoading(false);
                    //setLog('Неизвестная ошибка!');
                    setLoadingChat(false);
                    ErrorAdd(err, window.location.href);
                })
        }
    }

    const [sendLog, setSendLog] = useState(null);
    const [dataReset, setDataReset] = useState(null);


    //Сброс отправленных данных
    const handleReset = () => {
        //Только так срабатывают 2 setDataReset подряд
        setDataReset(true);

        setTimeout(() => {
            setDataReset(false);
        }, 100);
    };

    function sendHandler(chatId, text, files) {

        setSendLog(null);
        setLoadingMessage(true);

        var formData = new FormData();
        formData.append('ID_Ticket', chatId);
        formData.append('Message', text);

        if (files !== undefined & files !== null) {
            files.map(f => {
                formData.append('Files', f);
            })
        }

        //http://localhost:31687/api/test/testMessageAdd
        // /api/tracker/support/messageAdd
        axios.post('/api_tracker/ticket/messageAdd', formData, { headers: { 'Content-Type': 'multipart/form-data' } })
            .then((res) => {
                // console.log('res.data', res.data.Data)
                if (res.data.Status === 1) {
                    //dispatch(messageAdd({ model: res.data.Data, id_ticket: chatId }));
                    setLoadingMessage(false);
                    handleReset();
                }
                else {
                    setLoadingMessage(false);
                    setSendLog('Неизвестная ошибка! Повторите попытку позже или обратитесь в техническую поддержку по электронной почте: support@biz-office.ru');
                }
            })
            .catch((err) => {
                //setLog('Неизвестная ошибка!');
                setLoadingMessage(false);
                ErrorAdd(err, window.location.href);
                setSendLog('Неизвестная ошибка! Повторите попытку позже или обратитесь в техническую поддержку по электронной почте: support@biz-office.ru');
            });
    }

    //Конвертация сообщений в нужный формат
    useEffect(() => {
        setMessages(stateTicket.listMessage.map(item => {
            const files = item.Files === null ? null : (
                item.Files.map(f => {
                    return { idFile: f.ID_File, name: f.Name, idType: f.ID_Type }
                })
            )
            return {
                id: item.ID_Message
                , name: 'Без имени'
                , text: item.Text
                , id_ticket: item.ID_Ticket
                , myMessage: !item.Is_Support
                , date: item.Date_Add
                , files: files
            };
        }))
    }, [stateTicket.listMessage]);

    return (
        <div>
            {ticketShow === true ?
                (
                    <Chat chatId={chatId} chatName={chatName} hide={() => setTicketShow(false)} loading={loadingChat} loadingMessage={loadingMessage} messages={messages.filter(a => a.id_ticket === chatId)} sendHandler={sendHandler} log={sendLog} dataReset={dataReset} />
                ) :
                (
                    <div className='admin_content'>
                        {modalAddShow === true && (
                            <ModalAdd show={modalAddShow} onHide={() => setModalAddShow(false)} />
                        )}
                        <div className="mb-20">
                            <TabBar tabData={tab} tabSelected={tabSelected} tabClikHandler={tabHandler} filterShow={filterShow} setFilterShow={setFilterShow} showAdd={true} setAddShow={setModalAddShow} showFilter={false} />
                        </div>
                        {tab.map(tab => (
                            <div key={tab.id_tab} className={tab.id_tab !== tabSelected ? "d-none" : ""}>
                                {tab.error !== null ? (
                                    <LogError key={tab.id_tab} text={tab.error} />
                                ) : (
                                    <>
                                        {tab.loading === true ? (<div className="loader_01 mt-30"></div>)
                                            :
                                            (
                                                <div className="mt-20">
                                                    {stateTicket.list.filter(a => a.id_tab === tab.id_tab).length === 0 ? (
                                                        <InfoNoData text="Нет обращений" />
                                                    ) : (
                                                        <List key={0}
                                                            editHandler={editHandler}
                                                            list={stateTicket.list.filter(a => a.id_tab === tab.id_tab)}
                                                            idTab={tab.id_tab}
                                                        />
                                                    )}
                                                </div>
                                            )
                                        }
                                    </>
                                )}
                            </div>
                        ))}
                    </div>
                )}
        </div>
    )
}
export default Index;